import { EmpLearningPathStatusEnum } from '@pimm/services/lib/sms-workforce';

export const learningPathProgressValue = (value?: string): number => {
  let progress = Number(value);
  if (isNaN(progress) || !progress) return 0;
  return progress;
};

export const getLearningPathMetaStats = (
  status?: EmpLearningPathStatusEnum,
): { actionText: string; displayText: string; fillColor: string } => {
  switch (status) {
    case EmpLearningPathStatusEnum.Complete:
      return {
        actionText: 'app_insights:review',
        displayText: 'app_insights:completed',
        fillColor: 'blueLight.500',
      };
    case EmpLearningPathStatusEnum.Started:
      return {
        actionText: 'app_insights:resume',
        displayText: 'app_insights:started',
        fillColor: 'warning.400',
      };
    case EmpLearningPathStatusEnum.Enrolled:
      return {
        actionText: 'app_insights:start',
        displayText: 'app_insights:enrolled',
        fillColor: 'gray.200',
      };
    default:
      return {
        actionText: 'app_insights:tart',
        displayText: 'app_insights:pending',
        fillColor: 'gray.200',
      };
  }
};

export const assignmentMapping = [
  {
    dataField: 'servicePositionAssignments',
    title: 'app_insights:service_position_assignments',
    caption: 'app_insights:shift_checkpoints_assigned',
  },
  {
    dataField: 'nonServicePositionAssignments',
    title: 'app_insights:non_service_assignments',
    caption: 'app_insights:breakfast_open_lunch_readiness',
  },
  {
    dataField: 'positionalGoalAssignments',
    title: 'app_insights:daily_positional_goal_assignments',
    caption: null,
  },
];
